import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {
  FileIcon,
  Heading,
  ProfileIcon,
  SearchIcon,
  Text,
} from '@edume/magnificent';

import styles from './styles.module.scss';

function EmptyState({title, type, description}) {
  return (
    <div styleName='empty-state'>
      <div>
        {type === 'user' && <ProfileIcon colour={'grey300'} size='huge' />}
        {type === 'content' && <FileIcon colour={'grey300'} size='huge' />}
        {type === 'search' && <SearchIcon colour={'grey300'} size='huge' />}
        <Heading
          as='h2'
          colour='textPrimary'
          size='hamster'
          textTransform='none'
          weight='semiBold'
        >
          {title}
        </Heading>
        <Text
          colour='textSecondary'
          inline='false'
          lineHeight='tight'
          size='s'
          textTransform='none'
          weight='regular'
        >
          {description}
        </Text>
      </div>
    </div>
  );
}

EmptyState.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default CSSModules(EmptyState, styles, {allowMultiple: true});
